require('./assets/vendor/bootstrap-5.3.3/bootstrap.min.css')
// require('./assets/vendor/google-open-sans/font.css')
// require('./assets/vendor/google-handlee/font.css')
require('./assets/vendor/google-kumbh-sans/font.css')
require('./assets/vendor/google-gloria-hallelujah/font.css')
require('swiper/swiper-bundle.min.css')
// require('shariff/dist/shariff.min.css')
require('./assets/styles/app/app.less')

require('jquery')
require('swiper/swiper-bundle.min.js')
require('./assets/vendor/shuffle-js-5.4.1/shuffle.min.js')
// require('shariff')
require('./assets/js/custom.js')

require.context('./components/', true, /^\.\/(base\/errors|layouts\/master|errors|templates)\/.*\.less$/)

require('air-datepicker/air-datepicker.css');
require('air-datepicker/air-datepicker');
require('air-datepicker/locale/de');